import {
    Button,
    Checkbox,
    createStyles,
    FormControlLabel,
    WithStyles,
    withStyles,
} from '@material-ui/core';
import { inject } from 'mobx-react';
import React from 'react';
import ESDataTableWithHeader from 'src/common/ESDataTableWithHeader';
import IDataTableManager from 'src/common/IDataTableManager';
import { IObservation } from 'src/Definitions';
import { IStores } from 'src/Stores';
import ObservationTypes from 'src/utils/ObservationTypes';
import ObservationsLogic from './ObservationsLogic';

const styles = createStyles({});

interface IObservationProps extends WithStyles<typeof styles> {
    dataTableManager: IDataTableManager<IObservation>;
    getColumnSettingsAndObservations: (
        filter?: string,
        includeAllObservers?: boolean,
        thenFunction?: () => void
    ) => void;
    setSelectedObservation?: (observation: IObservation) => void;
}

class ObservationList extends React.Component<IObservationProps> {
    private _logic: ObservationsLogic = new ObservationsLogic();

    public state = {
        filters: {
            filterByBud: false,
            filterByIncludeAllObservers: true,
            filterByRose: false,
            filterByThorn: false,
        },
        showFilters: false,
    };

    public componentDidMount() {
        this.props.getColumnSettingsAndObservations();
    }

    public reloadObservations = (filterType: string) => () => {
        const checkBoxes = this._logic.updateCheckboxState(this.state.filters, filterType);
        const filter = this._logic.buildTypeFilter(checkBoxes);
        this.props.getColumnSettingsAndObservations(
            filter,
            checkBoxes.filterByIncludeAllObservers,
            () => {
                this.setState({ filters: checkBoxes });
            }
        );
    };

    public checkbox = (typeName: string) => () => {
        const filterStateKey = 'filterBy' + typeName;
        const color = this._logic.getColorFromObservationType(typeName);
        return (
            <FormControlLabel
                control={
                    <Checkbox
                        key={typeName.toLowerCase()}
                        data-cy={typeName}
                        checked={this.state.filters[filterStateKey]}
                        name={typeName}
                        style={{ color }}
                        onChange={this.reloadObservations(filterStateKey)}
                    />
                }
                label={this._logic.getLabel(typeName)}
            />
        );
    };

    public toggleFilters = () => {
        this.setState({ showFilters: !this.state.showFilters });
    };

    public hideCheckboxes = () => {
        return (
            <Button
                color="primary"
                variant="contained"
                style={{ marginRight: '20px' }}
                onClick={this.toggleFilters}
            >
                {this.state.showFilters ? 'Hide Filters' : 'Show Filters'}
            </Button>
        );
    };

    public render() {
        const filters = this.state.showFilters
            ? [
                  this.hideCheckboxes,
                  this.checkbox('IncludeAllObservers'),
                  this.checkbox(ObservationTypes.Rose),
                  this.checkbox(ObservationTypes.Thorn),
                  this.checkbox(ObservationTypes.Bud),
              ]
            : [this.hideCheckboxes];
        return (
            <ESDataTableWithHeader
                title="Observations"
                enableEdit={true}
                enableToggleColumns={true}
                additionalToggleFilters={filters}
                onRowClick={this.onRowClick}
                dataTableManager={this.props.dataTableManager}
            />
        );
    }

    public onRowClick = (
        _event: React.MouseEvent<Element>,
        observation: IObservation,
        _idx: number
    ) => {
        this.props.setSelectedObservation!(observation);
    };
}

const InjectedObservations = inject<IStores, IObservationProps, Partial<IObservationProps>, any>(
    (stores: IStores) => ({
        setSelectedObservation: stores.observations.setSelectedObservation,
    })
)(withStyles(styles)(ObservationList));

export default InjectedObservations;



// WEBPACK FOOTER //
// ./src/chevrons/behaviors/observations/ObservationList.tsx